import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RoutineItemType = {
  id: string | null;
  name: string | null;
  value: string | null;
  comment: string | null;
};

export type DailyRoutineType = {
  id: string | null;
  routines: RoutineItemType[];
  customRoutines: RoutineItemType[];
  easiestRoutine1: string | null;
  easiestRoutine1Comment: string | null;
  easiestRoutine2: string | null;
  easiestRoutine2Comment: string | null;
  easiestRoutine3: string | null;
  easiestRoutine3Comment: string | null;
  hardestRoutine1: string | null;
  hardestRoutine1Comment: string | null;
  hardestRoutine2: string | null;
  hardestRoutine2Comment: string | null;
  hardestRoutine3: string | null;
  hardestRoutine3Comment: string | null;
  sessionReviewedDate: string | null;
};

export type IfspReportDailyRoutineType = {
  ifspId: string | null;
  dailyRoutines: DailyRoutineType[];
  heldBy: string | null;
  isCurrentlyHeld: boolean;
};

export type IfspReportDailyRoutineTypeStateType = {
  originalIfspDailyRoutineReport: IfspReportDailyRoutineType;
  ifspDailyRoutineReport: IfspReportDailyRoutineType;
};

export const initialIfspDailyRoutineReportState: IfspReportDailyRoutineTypeStateType =
  {
    originalIfspDailyRoutineReport: {
      ifspId: null,
      dailyRoutines: [],
      heldBy: null,
      isCurrentlyHeld: false,
    },
    ifspDailyRoutineReport: {
      ifspId: null,
      dailyRoutines: [],
      heldBy: null,
      isCurrentlyHeld: false,
    },
  };

const ifspDailyRoutineSlice = createSlice({
  name: 'ifspDailyRoutineReport',
  initialState: initialIfspDailyRoutineReportState,
  reducers: {
    setIfspDailyRoutineReport: (
      state,
      action: PayloadAction<IfspReportDailyRoutineType>,
    ) => {
      state.ifspDailyRoutineReport = action.payload;
      state.originalIfspDailyRoutineReport = action.payload;
    },
    updateIfspDailyRoutineReport: (
      state,
      action: PayloadAction<Partial<IfspReportDailyRoutineType>>,
    ) => {
      state.ifspDailyRoutineReport = {
        ...state.ifspDailyRoutineReport,
        ...action.payload,
      };
    },
    updateOriginalIfspDailyRoutineReport: (
      state,
      action: PayloadAction<Partial<IfspReportDailyRoutineType>>,
    ) => {
      state.originalIfspDailyRoutineReport = {
        ...state.originalIfspDailyRoutineReport,
        ...action.payload,
      };
    },

    resetIfspDailyRoutineReport: () => initialIfspDailyRoutineReportState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialIfspDailyRoutineReportState,
    );
  },
});

export const {
  setIfspDailyRoutineReport,
  updateIfspDailyRoutineReport,
  updateOriginalIfspDailyRoutineReport,
  resetIfspDailyRoutineReport,
} = ifspDailyRoutineSlice.actions;

export default ifspDailyRoutineSlice.reducer;
